import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { useForm, Controller } from 'react-hook-form';

export default ({ classes, onSubmit, submitErrors }) => {
  
  const { register, handleSubmit, errors, control, setError } = useForm();

  useEffect(() => {
    submitErrors.map(error => {
      return setError(error.param, {
        type: 'manual',
        message: error.msg,
      });
    });
  }, [submitErrors, setError]);

  return (
    <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            inputRef={register({
              required: 'required',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'invalid email address',
              },
            })}
            variant="outlined"
            fullWidth
            error={errors.hasOwnProperty('email')}
            helperText={errors.email && errors.email.message}
            id="email"
            label="Email Address"
            name="email"
          />
        </Grid>
        <Grid item xs={12}>
          <FormControl variant="outlined" fullWidth error={!!errors.role_id}>
            <InputLabel id="role_id">Role</InputLabel>
            <Controller
              as={
                <Select>
                  <MenuItem value=""></MenuItem>
                  <MenuItem value={1}>Provider</MenuItem>
                  <MenuItem value={2}>Admin</MenuItem>
                </Select>
              }
              name="role_id"
              rules={{ required: 'required' }}
              control={control}
              defaultValue=""
            />
            <FormHelperText>{errors.role_id && errors.role_id.message}</FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        className={classes.submit}
      >
        Invite
      </Button>
    </form>
  );
};
